import { createSlice } from '@reduxjs/toolkit';
import ApiService from 'services/ApiService';
import axios from 'services/ApiAdaptor';

const getMultipartConfig = () => {
  const token = window.localStorage.getItem('serviceToken');
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
};

const initialState = {
  lists: {
    items: [],
    totalItems: 0
  },
  currentPage: 0,
  pageSize: 150,
  error: null,
  list: null,
  alertPopup: false
};

const slice = createSlice({
  name: 'productionPlanOutput',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    getSingleList(state, action) {
      state.list = action.payload;
    },
    createProductionPlanOutput(state, action) {
      state.lists.items = [...state.lists.items, action.payload];
      state.lists.totalItems += 1;
    },
    updateProductionPlanOutput(state, action) {
      const updatedOutput = action.payload;
      state.lists.items = state.lists.items.map((item) => (item.id === updatedOutput.id ? updatedOutput : item));
    },
    deleteProductionPlanOutput(state, action) {
      const outputId = action.payload;
      state.lists.items = state.lists.items.filter((item) => item.id !== outputId);
      state.lists.totalItems -= 1;
    },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertToggle;
    }
  }
});

export const {
  getLists,
  getSingleList,
  createProductionPlanOutput,
  updateProductionPlanOutput,
  deleteProductionPlanOutput,
  alertPopupToggle
} = slice.actions;

export default slice.reducer;

export function getProductionPlanOutputList(page, pageSize) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/productionPlanOutput/list',
        params: { page, pageSize }
      };
      const response = await ApiService.get(objData);
      console.log('response', response);
      dispatch(
        getLists({
          items: response.data.items,
          totalItems: response.data.totalItems,
          currentPage: page - 1,
          pageSize: pageSize
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getProductionPlanOutputInsert(NewLists) {
  return async (dispatch) => {
    try {
      const data = new FormData();
      Object.keys(NewLists).forEach((key) => {
        if (key === 'files' && NewLists[key] && NewLists[key][0]) {
          data.append('file', NewLists[key][0]);
        } else if (['bomItems', 'qualityItems'].includes(key) && Array.isArray(NewLists[key])) {
          data.append(key, JSON.stringify(NewLists[key]));
        } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
          data.append(key, typeof NewLists[key] === 'object' ? JSON.stringify(NewLists[key]) : NewLists[key]);
        }
      });
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/productionPlanOutput/productionPlanOutputUpload`,
        data,
        getMultipartConfig()
      );
      if (response.status === 200) {
        console.log('response', response);
        dispatch(createProductionPlanOutput(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getProductionPlanOutputSingleList(productionPlanOutputId) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/productionPlanOutput/list/single',
        data: { id: productionPlanOutputId }
      };
      const response = await ApiService.post(objData);
      dispatch(getSingleList(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getProductionPlanOutputUpdate(NewLists, id, flag) {
  return async (dispatch) => {
    try {
      let response;
      if (flag === 'Y') {
        const data = new FormData();
        Object.keys(NewLists).forEach((key) => {
          if (key === 'files' && NewLists[key] && NewLists[key][0]) {
            data.append('file', NewLists[key][0]);
          } else if (['bomItems', 'qualityItems'].includes(key) && Array.isArray(NewLists[key])) {
            data.append(key, JSON.stringify(NewLists[key]));
          } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
            data.append(key, typeof NewLists[key] === 'object' ? JSON.stringify(NewLists[key]) : NewLists[key]);
          }
        });
        response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/productionPlanOutput/productionPlanOutputUpdate`,
          data,
          getMultipartConfig()
        );
      } else {
        const objData = {
          path: '/productionPlanOutput/update',
          data: NewLists
        };
        response = await ApiService.post(objData);
      }

      if (response.status === 200) {
        dispatch(updateProductionPlanOutput(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getProductionPlanOutputDelete(productionPlanOutputId) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/productionPlanOutput/delete',
        data: { id: productionPlanOutputId }
      };
      const response = await ApiService.post(objData);
      if (response.status === 200) {
        dispatch(deleteProductionPlanOutput(productionPlanOutputId));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}
